export default function addDay(currentDate, days) {
  let date = new Date(currentDate);
  date.setDate(date.getDate() + days);
  return date.toDateString();
}
